<template>
	<div class="register-container">
		<div class="register-content">
			<div class="logo-container" @click="$router.replace({path: '/'})">
				<img src="../assets/logo.png" class="logo" />
			</div>
			<el-form ref="baseInfoForm" class="register-form" :model="baseInfoForm" :rules="baseInfoRules">
				<el-form-item label="" prop="nickname">
					<div class="form-group">
						<input type="text" v-model="baseInfoForm.nickname" placeholder="请输入昵称" class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="" prop="password">
					<div class="form-group">
						<input :type="showOldPwd ? 'text' : 'password'" v-model="baseInfoForm.password"
							placeholder="请输入登录密码" class="form-input" />
						<img class="showPwd" src="../assets/Personal/iconP.png" @click="showOldPwd = !showOldPwd"
							v-if="!showOldPwd" />
						<img class="showPwd" src="../assets/Personal/iconO.png" @click="showOldPwd = !showOldPwd"
							v-else />
					</div>
				</el-form-item>
				<el-form-item label="" prop="phone">
					<div class="form-group">
						<div class="phone-input-container">
							<input type="tel" v-model="baseInfoForm.phone" maxlength="11" placeholder="请输入手机号码"
								class="phone-input" />
							<button type="button" @click="getVerificationCode" :disabled="countdown > 0"
								class="get-code-btn">{{countdown > 0 ? countdown + 's后重新获取': '获取验证码'}}</button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="" prop="verificationCode">
					<div class="form-group">
						<div class="verification-container">
							<input type="text" v-model="baseInfoForm.verificationCode" placeholder="请输入验证码"
								class="verification-input" />
							<span v-if="showVerificationError" class="error-message">验证码错误</span>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<div class="agreement-container">
				<label class="agreement-label">
					<img class="agreement-checkbox" src="../assets/Register/checkSel.png" v-if="baseInfoForm.agreeTerms"
						@click="baseInfoForm.agreeTerms = false" />
					<img class="agreement-checkbox" src="../assets/Register/checkNor.png" v-else
						@click="baseInfoForm.agreeTerms = true" />
					<span class="agreement-text">我已阅读并同意</span>
					<div class="agreement-link" @click="userAgree = true">《3D鞋壳数字资源网平台用户服务协议》</div>
				</label>
			</div>

			<!-- 注册按钮 -->
			<button type="button" @click="register" class="register-btn">注册</button>

			<!-- 登录链接 -->
			<div class="login-link-container">
				<router-link to="/login" class="login-link">已有账号，去登录</router-link>
			</div>
		</div>
		<div class="copyright">
			Copyright © 2025 3D鞋壳数字 京ICP备2025019184号-2 <img class="police" src="../assets/Register/police.png"
				alt="" />浙公网安备33030202002306号
		</div>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'恭喜您已成功注册3D鞋壳资源网平台，马上开启您的探'"
			:descTwo="'索之旅吧！'" @clickOk="sucPop = false;$router.replace('/')" v-if="sucPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="'您好，当前手机号已注册，请输入新的手机号'"
			@clickOk="tipPop = false" v-if="tipPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/abnormal.png')" :desc="'登录异常'" @clickOk="abnormalPop = false"
			v-if="abnormalPop" />
		<UserSeverAgreeDialog :show="userAgree" @close="userAgree = false" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import UserSeverAgreeDialog from '../components/UserSeverAgreeDialog.vue'
	export default {
		name: 'RegisterPage',
		components: {
			PopToast,
			UserSeverAgreeDialog,
		},
		data() {
			return {
				baseInfoForm: {
					nickname: '',
					password: '',
					email: '',
					phone: '',
					verificationCode: '',
					inviteCode: '',
					agreeTerms: true,
				},
				showVerificationError: false,
				showInviteError: false,
				countdown: 0,
				sucPop: false,
				tipPop: false,
				showOldPwd: false,
				abnormalPop: false,
				userAgree: false,
				baseInfoRules: {
					nickname: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入登录密码',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}],
					verificationCode: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					agreeTerms: [{
						required: true,
						message: '请阅读并同意用户协议',
					}],
				}
			}
		},
		methods: {
			// 获取验证码
			getVerificationCode() {
				this.$refs.baseInfoForm.validateField('phone', (valid) => {
					if (!valid) {
						this.$api.post('/Other/phone_code', {
							phone: this.baseInfoForm.phone,
						}).then(res => {
							if (res.code == 1) {
								this.countdown = 60;
								// 倒计时
								const timer = setInterval(() => {
									this.countdown--;
									if (this.countdown <= 0) {
										clearInterval(timer);
									}
								}, 1000);
							} else {
								console.log(res.msg)
							}
							console.log(res)
						}).catch(err => {
							console.log(err);
						})
					} else {
						return
					}
				});
			},

			// 注册
			register() {
				this.$refs.baseInfoForm.validate((valid) => {
					if (valid) {
						if (!this.baseInfoForm.agreeTerms) return this.$message.error('请阅读并同意用户协议')
						this.$api.post('/Basics/register', {
							user_nickname: this.baseInfoForm.nickname,
							user_email: this.baseInfoForm.email,
							mobile: this.baseInfoForm.phone,
							pwd: this.baseInfoForm.password,
							code: this.baseInfoForm.verificationCode,
							tj_num: this.baseInfoForm.inviteCode,
						}).then(res => {
							if (res.code == 1) {
								localStorage.setItem('token', res.data)
								this.showVerificationError = false
								this.showInviteError = false
								this.$api.post('/UserD/user_details', {}).then(response => {
									if (response.code == 1) {
										localStorage.setItem('userId', response.data.id)
										this.$store.dispatch('updateShopStatus', 1)
									}
								}).catch(err => {
									console.log(err);
								})
								this.sucPop = true
							} else {
								if (res.msg == "手机号已存在") {
									this.tipPop = true
									this.showInviteError = false
									this.showVerificationError = false
								} else if (res.msg == "验证码错误" || res.msg == "请先获取验证码") {
									this.showVerificationError = true
									this.showInviteError = false
								} else if (res.msg == "推荐码错误") {
									this.showVerificationError = false
									this.showInviteError = true
								} else {
									this.abnormalPop = true
								}
							}
						}).catch(err => {
							this.abnormalPop = true
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.register-container {
		width: 100%;
		height: 100vh;
		background: #080808;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.register-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 4.85rem;
		background: #1F2027;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		z-index: 1;
	}

	.logo-container {
		margin-top: 0.5rem;
		cursor: pointer;

		.logo {
			width: 1.4rem;
			height: .36rem;
		}
	}

	// 表单样式
	.register-form {
		width: 3.85rem;
		margin-top: .32rem;
	}

	.form-group {
		width: 3.85rem;
		height: .52rem;
		background: rgba(255, 255, 255, .08);
		position: relative;

		.showPwd {
			position: absolute;
			top: calc(50% - .12rem);
			right: .1rem;
			width: .24rem;
			height: .24rem;
			cursor: pointer;
		}
	}

	.form-input {
		width: 100%;
		height: 0.52rem;
		border: none;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		font-size: 0.14rem;
		color: #FFFFFF;
		line-height: .52rem;
		outline: none;
		transition: border-color 0.3s ease;
		background: none;

		&::placeholder {
			color: rgba(255, 255, 255, .4);
		}
	}

	// 手机号和验证码输入框样式
	.phone-input-container,
	.verification-container {
		width: 100%;
		height: 0.52rem;
		border: none;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		font-size: 0.14rem;
		color: #333333;
		line-height: .52rem;
		outline: none;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.phone-input,
	.verification-input,
	.invite-input {
		border: none;
		outline: none;
		height: 0.52rem;
		padding: 0 0;
		font-size: 0.14rem;
		color: #FFFFFF;
		line-height: .52rem;
		background: none;

		&::placeholder {
			color: #999999;
		}
	}

	.get-code-btn {
		padding: 0 0;
		color: #98E83E;
		font-size: 0.14rem;
		cursor: pointer;

		&:disabled {
			background: none;
			color: #CCCCCC;
			border: none;
			cursor: not-allowed;
		}
	}

	// 错误提示样式
	.error-message {
		display: flex;
		align-items: center;
		background: #F56C6C;
		padding: 0.04rem 0.09rem;
		border-radius: 0.02rem;
		font-weight: 400;
		font-size: 0.12rem;
		color: #FFFFFF;
		line-height: .22rem;
	}

	// 服务协议样式
	.agreement-container {
		margin: 0 0;
		width: 3.85rem;
		font-size: 0.14rem;
	}

	.agreement-label {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.agreement-checkbox {
		margin-right: 0.08rem;
		width: .16rem;
		height: .16rem;
		cursor: pointer;
	}

	.agreement-text {
		font-weight: 400;
		color: #828387;
		margin-right: 0.04rem;
	}

	.agreement-link {
		font-weight: 400;
		color: #98E83E;
	}

	// 按钮样式
	.register-btn {
		margin: .24rem auto 0;
		width: 3.85rem;
		height: 0.52rem;
		background: #1673E6;
		padding: 0 0;
		border: none;
		border-radius: 0.26rem;
		font-size: 0.16rem;
		color: #FFFFFF;
		font-weight: 500;
		line-height: .52rem;
		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover {
			background: #1673E6;
		}
	}

	// 登录链接样式
	.login-link-container {
		margin-top: 0.16rem;
		margin-bottom: .5rem;
		width: 3.85rem;
		height: .52rem;
		border-radius: .26rem;
		border: .01rem solid rgba(255, 255, 255, .8);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&:hover {
			.login-link {
				color: rgba(255, 255, 255, .8);
			}
		}
	}

	.login-link {
		font-weight: 400;
		font-size: .15rem;
		color: rgba(255, 255, 255, .8);
		text-decoration: none;
	}

	.copyright {
		position: fixed;
		bottom: .16rem;
		// left: 50%;
		// transform: translateX(-50%);
		font-weight: 400;
		font-size: .12rem;
		color: rgba(188, 188, 190, .5);
		display: flex;
		align-items: center;

		.police {
			margin-left: .12rem;
			margin-right: .04rem;
			width: .14rem;
			height: .14rem;
		}
	}

	::v-deep .el-form-item {
		margin-right: 0 !important;
		margin-bottom: .16rem !important;
		font-size: .14rem;
		line-height: 0.44rem;

		&__content {
			font-size: .14rem;
			line-height: 0.44rem;
		}

		&__error {
			font-size: .12rem;
			padding-top: .02rem;
		}
	}
</style>